import React, { Component } from "react";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import { PSellAction, PSRole, SellRequestListing } from "../../../apis/privatesell/enitites";
import { privateSellApi } from "../../../apis/privatesell";
import { TabuProfile } from "@10x/sso/TabuProfile";
import { hideLoading, showLoading, showMessage } from "@my-dld/utils/UIUtils";
import ListGridDataView from "@my-dld/components/DataView/ListGridDataView";
import Strings from "@my-dld/assets/strings";
import PSellGridView from "@my-dld/components/MyRequest/PSellGridView";
import PSellListView from "@my-dld/components/MyRequest/PSellListView";
import { navigate } from "@my-dld/utils/StoreUtils";
import { getParentFullPath } from "@my-dld/utils/PathUtils";

const pageSize = 50;

interface State {
	isLoading: boolean;
	requests: SellRequestListing[];
	selectedFilterId: number,
	pageNumber: number;
	hasMore: boolean;
}

export default class PrivateSellRequests extends Component<RoutedViewProps, State> {
	constructor( props: RoutedViewProps ) {
		super( props );
		this.state = {
			hasMore: true,
			isLoading: true,
			requests: [],
			pageNumber: 0,
			selectedFilterId: 0,
		};
		this.onAction = this.onAction.bind( this );
	}

	componentDidMount() {
		this.loadRequests();
	}

	render() {
		const { isLoading, requests } = this.state;
		return <React.Fragment>
			<ListGridDataView
				isLoading={ isLoading }
				dataAvailable={ requests.length > 0 }
				title={ Strings.my_sell_requests }
				renderListView={ this.renderListView }
				renderGridView={ this.renderGridView }/>
		</React.Fragment>;
	}

	private loadRequests() {
		const p = TabuProfile.getProfile();
		const { pageNumber, selectedFilterId } = this.state;
		if ( p ) {
			showLoading();
			privateSellApi.mySellRequests( p.tabuParticipantId!.toString(), pageSize, pageNumber, selectedFilterId.toString() )
			.then( rsp => {
				hideLoading();
				this.setState( {
					requests: rsp.listings,
					isLoading: false,
				} );
			} )
			.catch( exp => {
				hideLoading();
				this.setState( { isLoading: false } );
			} );
		}

	}

	private onAction( action: PSellAction, request: SellRequestListing ) {
		// this.setState({selectedAction: action, selectedRequest: request});
		// if (action.actionId === "CanCancelled" || action.actionId === "ViewRemark") {
		//     this.setState({selectedRequest: request, selectedAction: action});
		// } else if (action.actionId === "CanReSubmit") {
		//     this.onViewRequest(request, Mode.EDIT);
		// } else if (action.actionId === "CanView") {
		//     this.onViewRequest(request, Mode.VIEW);
		// }
		showLoading();
		privateSellApi.getSellRequestById( request.id.toString() ).then( ( resp: SellRequestListing ) => {
			hideLoading();
			const currentPath = getParentFullPath( this.props.location.pathname, "my_requests" );
			navigate( currentPath + `/privateSell/${ request.id }`,
				undefined, {
					listItem: request,
					result: resp,
					role: PSRole.SELLER,
				} );
		} ).catch( exp => {
			hideLoading();
			showMessage( exp.toString() );
		} );
	}

	private renderListView = () => {
		const { requests, } = this.state;
		return <div className="enoc-mollok-request"><PSellListView
			items={ requests }
			isAction={ false }
			onAction={ this.onAction }
		/></div>;
	};

	private renderGridView = () => {
		const { requests } = this.state;
		return <PSellGridView
			items={ requests }
			onAction={ this.onAction }/>;
	};
}
